import { Box, Typography, Link, Grid, Pagination, Skeleton } from "@mui/material";
import { useState, useEffect } from "react";
import { Link as RouterLink } from "react-router-dom";
import defaultImg from "assets/images/blog/1.jpg";

const DASHBOARD_URL =
  process.env.REACT_APP_DASHBOARD_URL || "https://amrithospitals.com/amritapi";

const resolveMediaUrl = (url) => {
  if (!url) return defaultImg;
  if (/^(https?:)?\/\//i.test(url) || url.startsWith("data:")) return url;
  return `${DASHBOARD_URL}/${url.replace(/^\/+/, "")}`;
};

const BlogItem = ({ img, title, text }) => (
  <Box>
    <Box>
      <img
        src={resolveMediaUrl(img)}
        alt={title}
        width="100%"
        height="100%"
        style={{ objectFit: "cover", borderRadius: "0.5rem" }}
      />
    </Box>
    <Box>
      <Typography fontSize="1.25rem" fontWeight="bold" mb={2}>
        {title}
      </Typography>
      <Typography variant="body1">{text}</Typography>
    </Box>
  </Box>
);

const BlogSkeleton = () => (
  <Grid container spacing={5}>
    {Array.from({ length: 9 }).map((_, i) => (
      <Grid item xs={12} sm={6} md={4} key={i}>
        <Box boxShadow="0 0 10px 0 rgba(153,153,153,0.2)" p={4} borderRadius="1rem" bgcolor="common.white">
          <Skeleton variant="rectangular" width="100%" height={200} sx={{ borderRadius: "0.5rem", mb: 2 }} />
          <Skeleton variant="text" width="90%" height={32} sx={{ mb: 1 }} />
          <Skeleton variant="text" width="100%" />
          <Skeleton variant="text" width="80%" />
        </Box>
      </Grid>
    ))}
  </Grid>
);

const Blogs = () => {
  const [page, setPage] = useState(1);
  const [blogs, setBlogs] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const ITEMS_PER_PAGE = 9;

  useEffect(() => {
    setLoading(true);
    setError(null);
    fetch(`${DASHBOARD_URL}/api.php?action=get_public_blogs&page=${page}&limit=${ITEMS_PER_PAGE}`)
      .then((r) => {
        if (!r.ok) throw new Error("Server error: " + r.status);
        return r.json();
      })
      .then((data) => {
        setBlogs(data.blogs || []);
        setTotalPages(data.pages || 1);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Blog fetch error:", err);
        setError(true);
        setLoading(false);
      });
  }, [page]);

  const handleChange = (event, value) => {
    setPage(value);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Box py={{ md: 10, xs: 4 }} px={{ md: 18, xs: 4 }} bgcolor="#f6f6f6">
      <Typography fontSize={"3.125rem"} fontWeight="bold" mb={6} textAlign="center">
        Latest Blog & News
      </Typography>

      {loading && <BlogSkeleton />}

      {error && (
        <Box textAlign="center" py={8}>
          <Typography color="error">Blogs load nahi ho sake. Server check karein.</Typography>
        </Box>
      )}

      {!loading && !error && blogs.length > 0 && (
        <Grid container spacing={5}>
          {blogs.map((blog, index) => (
            <Grid item xs={12} sm={6} md={4} key={blog.slug || index}>
              <Link
                boxShadow={"0 0 10px 0 rgba(153, 153, 153, 0.2)"}
                p={4}
                height={"calc(100% - 3rem)"}
                borderRadius={"1rem"}
                bgcolor={"common.white"}
                component={RouterLink}
                to={`/blog/${blog.slug}`}
                textDecoration="none"
                color="common.black"
                sx={{ textDecoration: "none", display: "inline-table", "&:hover": { textDecoration: "none" } }}
              >
                <BlogItem
                  img={blog.featured_image || defaultImg}
                  title={blog.title}
                  text={blog.excerpt || ""}
                />
              </Link>
            </Grid>
          ))}
        </Grid>
      )}

      {!loading && !error && blogs.length === 0 && (
        <Box textAlign="center" py={8}>
          <Typography color="text.secondary" fontSize="1.2rem">
            Abhi koi blog publish nahi hua.
          </Typography>
        </Box>
      )}

      {totalPages > 1 && (
        <Box display="flex" justifyContent="center" mt={4}>
          <Pagination count={totalPages} page={page} onChange={handleChange} color="primary" />
        </Box>
      )}
    </Box>
  );
};

export default Blogs;
